import { IonButton } from '@ionic/react';
import styled from 'styled-components';
import { system, typography, } from 'styled-system';
import { transient } from '../../../utils';
const GrapeButton = styled(IonButton).attrs(props => ({
    dataCy: props.type === 'submit' ? 'submitButton' : props.dataCy,
})) `
  ${transient(system({ textTransform: true }))}
  ${transient(typography)}
`;
GrapeButton.defaultProps = {
    $fontWeight: 'bold',
    $shape: 'round',
    $textTransform: 'none',
};
export { GrapeButton };
//# sourceMappingURL=index.js.map